// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"1175":"PrototypeViewer","1628":"livekit-egress-template"}[chunkId] || chunkId) + "." + {"1175":"9ef84ea04324ad8020d0","1628":"5f9f443a103b4f47e60a","2054":"9ef84ea04324ad8020d0","6095":"9b0d3d900fc072ffccd0","7203":"3b22cc1a39ef867a9c56","7844":"ab59e503dc35a1d1dec5"}[chunkId] + ".chunk.css";
};